import { SiteViewportActionType } from './site-viewport-action-type';

export interface SetSiteViewportFullscreenAction {
  fullscreen: boolean;
  type: SiteViewportActionType.SetFullscreen;
}

export const setSiteViewportFullscreen = (
  fullscreen: boolean = true,
): SetSiteViewportFullscreenAction => ({
  fullscreen,
  type: SiteViewportActionType.SetFullscreen,
});
